import { AzSearchStore } from "dw_azsearchstore";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Provider } from "react-redux";
import { azStoreConfig } from "../azStoreConfig";
import { useConfig } from "./configContext";

const AzStoreContext = React.createContext<AzSearchStore>(new AzSearchStore());

export const AzStoreProvider = ({children}) => {    
    const [azStore, setAzStore] = useState<AzSearchStore>(new AzSearchStore());
    const config = useConfig();

    const getAzStore = useCallback(() => {
        config.azStoreConfig && config.azStoreConfig.index &&
            setAzStore(azStoreConfig(config).azStore)
    }, [azStoreConfig, config.azStoreConfig])

    useEffect(getAzStore, [getAzStore]);

    return (
        azStore.store.getState().config.index !== '' ?
                <AzStoreContext.Provider value={azStore}>
                    <Provider store={azStore.store}>
                        {children}
                    </Provider>
                </AzStoreContext.Provider>
                : null
    )

}

export default AzStoreContext;

export const useAzSearchStore = ():AzSearchStore => useContext(AzStoreContext);
